<template>
    <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :title="ruleTitle.rule" :value="ruleGame"/>
      <rule-game :title="ruleTitle.player" :value="rulePlayer"/>
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/ntpp/ntpp-board.png';
import ntppOne from '../../assets/gamerule/ntpp/ntpp1.png';
import ntppTwoone from '../../assets/gamerule/ntpp/ntpp2-1.png';
import ntppTwotwo from '../../assets/gamerule/ntpp/ntpp2-2.png';
import ntppThreeone from '../../assets/gamerule/ntpp/ntpp3-1.png';
import ntppThreetwo from '../../assets/gamerule/ntpp/ntpp3-2.png';
import ntppFour from '../../assets/gamerule/ntpp/ntpp4.png';
import ntppFive from '../../assets/gamerule/ntpp/ntpp5.png';
import playOne from '../../assets/gamerule/player/1.png';
import playTwo from '../../assets/gamerule/player/2.png';
import playThree from '../../assets/gamerule/player/3.png';

export default {
  name: 'rule_ntpp',
  data() {
    return {
      ruleHeader: {
        gameName: 'น้ำเต้าปูปลา (NTPP)',
        boardImg: Board,
      },
      ruleTitle: {
        rule: 'กติกา',
        player: 'ผู้เล่น',
      },
      ruleGame: [
        {
          type: 'text',
          text: '1. จำนวนผู้เล่นต่อ 1 ห้อง มีได้ตั้งแต่ 2-50 คน เมื่อเข้ามาในห้องแล้วจะเริ่มเล่นได้ทันที',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: ntppOne,
          class: 'w-50',
        },
        {
          type: 'text',
          text: '2. วิธีเดิมพันมี 2 ประเภท คือ เต็งและคู่ ผู้เล่นมีเวลา 30 วินาที ในการวางเดิมพัน',
          class: 'ml-3',
        },
        {
          type: 'twoImage',
          image: ntppTwoone,
          class: 'w-100',
          image2: ntppTwotwo,
        },
        {
          type: 'text',
          text: '3. เมื่อหมดเวลาระบบจะทำการสุ่มออกผลโดยอัตโนมัติ',
          class: 'ml-3',
        },
        {
          type: 'twoImage',
          image: ntppThreeone,
          class: 'w-100',
          image2: ntppThreetwo,
        },
        {
          type: 'text',
          text: '4. เดิมพันแบบเต็ง ( เดี่ยว ) แล้วผลออกมาตรงตามที่เดิมพันไป หากออก 1 ตัวจ่าย 1 เท่า : ออก 2 ตัว จ่าย 2 เท่า: ออก 3 ตัว จ่าย 3 เท่า : เช่นผู้เล่นเดิมพัน "เสือ" 100 บาท หากผลออกเป็น "เสือ" "เสือ" "ปลา" ผู้เล่นจะได้รับเงิน 200 บาท',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: ntppFour,
          class: 'w-50',
        },
        {
          type: 'text',
          text: '5. เดิมพันแบบโต๊ด (คู่) หากผู้เล่นเดิมพันโต๊ะ (คู่) แล้วผลออกมาตรงตามที่เดิมพันไป จ่าย 5 เท่า เช่น “ปู” “เสือ” จำนวน 100 บาท หากผลทอยลูกเต๋าออกเป็น “ปู” “เสือ” “ไก่” ผู้เล่นจะได้รับเงิน 500 บาท',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: ntppFive,
          class: 'w-50',
        },
      ],
      rulePlayer: [
        {
          type: 'text',
          text: 'ผู้เล่นสามารถเลือกชิป ในการลงเดิมพันได้และถ้าหาก จำนวนเงินของผู้เล่นน้อยกว่าชิป จะไม่สามารถทำการเลือกชิปที่มีมูลค่าสูงกว่าได้',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: playThree,
          class: 'w-50',
        },
        {
          type: 'text',
          text: 'การเดิมพันในแต่ละรอบจะอิงจากยอกขั้นต่ำ ( Minimum ) กับยอดเดิมพัน',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: playTwo,
          class: 'w-30',
        },
        {
          type: 'text',
          text: 'สามารถกดปุ่ม ยืนยัน หรือ ยกเลิกได้ถ้าไม่กดยืนยันถือว่าไม่ได้ทำการเดิมพัน',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: playOne,
          class: 'w-30',
        },
      ],
    };
  },
};
</script>
